import { render, staticRenderFns } from "./houseRecordInterview.coponents.vue?vue&type=template&id=1a15dd5c&scoped=true"
import script from "./houseRecordInterview.coponents.vue?vue&type=script&lang=js"
export * from "./houseRecordInterview.coponents.vue?vue&type=script&lang=js"
import style0 from "./houseRecordInterview.coponents.vue?vue&type=style&index=0&id=1a15dd5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15dd5c",
  null
  
)

export default component.exports